<!-- src/apps/colonel/views/ColonelSystemAuthDB.vue -->

<script setup lang="ts">
  // No i18n needed - admin-only view with hardcoded strings
</script>

<template>
  <div class="p-6">
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Auth Database (SQLite/PostgreSQL)</h1>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">Authentication database information</p>
    </div>

    <div class="bg-white dark:bg-gray-800 rounded-lg p-6 shadow">
      <div class="text-center text-gray-600 dark:text-gray-400">
        <p class="text-lg mb-2">Coming Soon</p>
        <p class="text-sm">Authentication database metrics will be available here</p>
      </div>
    </div>
  </div>
</template>
